const hospitalData = [
    {
        state: 'abia',
        hospital: [
            {
                name: 'Federal Medical Center, Umuahia',
                address: 'No. 1 Airport Road, Umuahia',
                phone: '08148573935'
            },
            {
                name: 'New Heritage Hospital and Maternity, Aba',
                address: 'KM 15 Enugu/Aba Expressway, Aba',
                phone: '08174562011'
            },
        ]
    },
    
    {
        state: 'adamawa',
        hospital: [
            {
                name: 'Sexual Assault Report Center, Umuahia',
                address: 'No. 1 Airport Road, Umuahia',
                phone: '08137926904'
            },
            {
                name: 'Sexual Assault Report Center, Umuahia',
                address: 'No. 1 Airport Road, Umuahia',
                phone: '08137926904'
            },
            {
                name: 'Sexual Assault Report Center, Umuahia',
                address: 'No. 1 Airport Road, Umuahia',
                phone: '08137926904'
            },
            {
                name: 'Sexual Assault Report Center, Umuahia',
                address: 'No. 1 Airport Road, Umuahia',
                phone: '08137926904'
            },
        ]
    },
]

export default hospitalData;